export class SuccessModel {
  CookingTime: number;
  SendingTime: number;
  constructor() {
    this.CookingTime = 0;
    this.SendingTime = 0;
  }
}
